import savingActionTypes from '../../constants/saving-action-types';

const createSiteProperty = (name, value) => ({
  type: savingActionTypes.CREATE_SITE_PROPERTY,
  name,
  value,
});

export default createSiteProperty;
